export default __webpack_public_path__ + "static/media/photo20.40fbb612.jpg";